import "../../Dashboard.css";

import { Link } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import Button from "react-bootstrap/Button";

import EvaluationAnalytics from '../EvaluationAnalytics';

import { useAuth } from "../../provider/authProvider";
import { useEffect, useState } from "react";

function Index() {
    const { user, name, rol } = useAuth();
    const [verifyDuplicate, setVerifyDuplicate] = useState(
        localStorage.getItem("duplicate") || "",
    );

    const localStorageRemove = [
        "phoneName",
        "creditRecord",
        "phonePrice",
        "initialPriceArr",
        "daysPaymentDays",
        "tcea",
        "initialPricePosition",
        "initialPrice",
        "initialPercent",
        "paymentFrequency",
        "numFee",
        "fee",
        "amountFinance",
        "totalAmountFinance",
        "fullName",
        "lastName",
        "dni",
        "phoneNumber",
        "email",
        "dniFront",
        "dniBack",
        "clientVideo",
        "livingPlace",
        "department",
        "city",
        "location",
        "locationNumber",
        "jobType",
        "jobName",
        "jobDirec",
        "civilStatus",
        "creditCard",
        "dependents",
        "monthlyIncome",
        "monthlyExpenses",
        "contractDate",
        "tycSignContract",
        "daysPayment",
        "idEnrrol",
        "dniEnroll",
        "imei",
        "duplicate",
        "servicePay",
        "loanType",
        "linkNumber",
        "verifyLocation",
    ];

    function useIsMobileUA() {
        const [isMobile, setIsMobile] = useState(false);

        useEffect(() => {
            const ua = (navigator.userAgent || "").toLowerCase();
            setIsMobile(/iphone|ipad|ipod|android/.test(ua));
        }, []);

        return isMobile;
    }

    useEffect(() => {
        for (let countLS in localStorageRemove) {
            localStorage.removeItem(localStorageRemove[countLS]);
        }

        return () => {
            if (verifyDuplicate === "1") {
                alert("Moviles Pay: El usuario se encuentra financiado.");
                for (let countLS in localStorageRemove) {
                    localStorage.removeItem(localStorageRemove[countLS]);
                }
                // alert('MovilesPay: El Usuario se encuentra en Proceso de Pagó')
            }
            localStorage.removeItem("completed");
            // localStorage.removeItem('completed')
            localStorage.removeItem("initialPercent");
            localStorage.removeItem("linkNumber");
        };
    }, []);

    return (
        <div>
            <Header user={user} />

            <section className="sectionBody">
                <div className="containerCustom containerBody">
                    <div className="blockBody">
                        <h2 className="titleBody">Bienvenido/a, {name}</h2>

                        <div
                            className="home-main-actions"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "stretch",
                                flexWrap: "wrap",
                                gap: "12px",
                                marginTop: "24px",
                            }}
                        >
                            <Link
                                to="/evaluation-system/credit-flow"
                                style={{ display: "flex", flex: "0 1 240px", minWidth: "200px", textDecoration: "none" }}
                            >
                                <Button
                                    variant="success"
                                    className="buttonGoFinan verifyClientButton"
                                    size="lg"
                                    style={{ width: "100%", minHeight: "52px", margin: 0 }}
                                >
                                    NUEVO CRÉDITO
                                </Button>
                            </Link>

                            {String(rol) === "1" && (
                                <Link
                                    to="/analytics"
                                    style={{ display: "flex", flex: "0 1 240px", minWidth: "200px", textDecoration: "none" }}
                                >
                                    <Button
                                        variant="primary"
                                        className="buttonGoFinan"
                                        size="lg"
                                        style={{ width: "100%", minHeight: "52px", margin: 0 }}
                                    >
                                        VER ANALÍTICAS
                                    </Button>
                                </Link>
                            )}
                        </div>

                        {String(rol) === "1" && <EvaluationAnalytics />}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default Index;
